@if (this.isVisible()) {
  <nav class="navbar fixed-top navbar-expand-lg navbar-light appHeader" id='header'>
    <a class="navbar-brand" href="#">{{ this.getTitle() }}</a>
    @if (getStrapline()) {
      <span class='strapline'>{{ this.getStrapline() }}</span>
    }
    <nav aria-label="breadcrumb" class='breadcrumbNav'>
      <ol class="breadcrumb">
        @if (getUrlParts()[0] !== "home") {
          <li class="breadcrumb-item"><a href="/">Home</a></li>
        }
        @for (item of getUrlParts(); track item; let i = $index) {
          @if (["edit", "view", "cancel", "new"].indexOf(item) ===-1 && (i +1) !== getUrlParts().length) {
            <li class="breadcrumb-item"><a href="javascript:void(0)" (click)=' navigate(i); $event.preventDefault();'>{{ getTidiedUpUrlPart(item) }}</a></li>
          }
          @if (["edit", "view", "cancel", "new"].indexOf(item) !==-1 || (i +1) === getUrlParts().length) {
            <li class="breadcrumb-item active">{{ getTidiedUpUrlPart(item) }}</li>
          }
        }
      </ol>
    </nav>
    <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarColor01" aria-controls="navbarColor01" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="collapse navbar-collapse" id="navbarColor01">
      <ul class="navbar-nav mr-auto">
        @for (item of this.getMenuItems(); track item) {
          <li class="nav-item">
            <a class="nav-link" href='#' [style.color]='item.foreColor' (click)='this.onHeaderItemClicked(item);$event.preventDefault();'>{{ item.name }}</a>
          </li>
        }
      </ul>
      <div class='headerActions'>
        <div class='alertContainer'>
          <!-- <div class='alertCounter'>1</div> -->
          <i class="fas fa-bell"></i>
        </div>
        <ul class="navbar-nav">
          <li class="nav-item dropdown">
            <a class="nav-link dropdown-toggle userMenuToggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
              <img class='avatar' src='https://eu.ui-avatars.com/api/?name={{this.getAvatar()}}&size=32'>
              <span>{{ this.getUsername() }}</span>
            </a>
            <div class="dropdown-menu dropdown-menu-right" aria-labelledby="navbarDropdown">
              <a class="dropdown-item" (click)='gotoProfile()'><i class="fas fa-user fa-fw"></i> Profile</a>
              <a class="dropdown-item" href="#" (click)='this.logout(); $event.preventDefault()'><i class="fas fa-sign-out-alt fa-fw"></i> Logout</a>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </nav>
}
